<template>
    <div>
        <div  :style="{height: tableHeight+'px',minWidth: '300px',overflowY: 'auto'}">

        <el-tree
                ref="tree"
                :data="treeData"
                lazy
                :load="loadNode"
                :props="defaultProps"
                node-key="wyid"
                @node-click="handleNodeClick"
                :default-expanded-keys="[0]"
                class="trees  video-tree height100"
                accordion
                :highlight-current='true'
                :expand-on-click-node="false">
<!--            <div class="custom-tree-node" style="width: 100%"  slot-scope="{ node, data }">-->
<!--                <div>-->
<!--                    <span><i :class="data.type==1?'el-icon-folder-folder-opened':'el-icon-folder-document'" style="padding-right: 5px"></i>{{ node.label }}</span>-->
<!--                    -->
<!--                </div>-->
<!--            </div>-->
        </el-tree>

        </div>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <el-button type="primary" @click="saveForm" :class="baseerp+'btn'" size="mini"  :disabled="disabled" >{{$t('button_confirm')}}</el-button>
            <el-button @click="cancel" size="mini">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";

    export default {
        name: "TransferCpfl",
        components: {},
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                defaultProps: {
                    children: 'children',
                    label: 'label',
                    isLeaf: 'isLeaf',
                    value:'i_id'
                },
                treeData:[],
                baseerp:'',
                chooseNode:null,
                tableHeight:0,
                disabled:false,
        }
        },
        watch:{
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.$nextTick(()=>{
                this.onResize();
            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3;
                if(this.tableHeight<60)this.tableHeight=60;
            },
            handleNodeClick(val){
                this.chooseNode=val
            },
            cancel(){
                this.$emit('close',null)
            },
            saveForm(){
                if(this.chooseNode.childProduct>0){
                    this.$message.warning('不能移动到该分类下')
                    return
                }
                this.productTypeSwitch()
                this.disabled=true;
            },
            loadNode(node, resolve) {
                let _this=this;
                if (node.level === 0) {
                    let val={i_id:0,i_level:0, type:1,i_pid:0,label:'全部',wyid:0,children:[],isLeaf:false}
                    // setTimeout(() => {
                    //         _this.productTree(val,resolve,node.level);
                    // }, 100)
                    return resolve([val]);

                }
                if (node.level>=1&&node.data.isLeaf==false){
                    _this.productTree(node.data,resolve,node.level);
                }
            },
            async productTree({i_id=0,type=0},resolve,level){
                let param = {
                    // i_mid: this.mid,
                    i_pid:i_id,
                };
                let res = await API.productTree(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash=one;
                            hash.isLeaf= one.childProduct==0&&one.childKind==0;
                            hash.i_level= level;
                            hash.label= one.vc_name;
                            hash.wyid=one.i_typeid+'-'+one.i_id

                            //     {
                            //     label:one.vc_name,
                            //     i_id:one.i_id,
                            //     type:one.type,
                            //     i_level:level+1,
                            //     // i_pid:one.i_pid,
                            //     isLeaf: one.childProduct==0,
                            // };
                            list.push(hash);
                        })
                    }
                    return resolve(list);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async productTypeSwitch() {
                let param={
                    i_typeid:this.data.i_id,
                    i_pid:this.chooseNode.i_id,
                    i_level:this.data.i_level,

                };
                let res = await API.productTypeSwitch(param);
                if (res.code == 1) {
                    this.$emit('close','save');
                    this.$message.success(res.message);
                    this.disabled=false
//console.log(res, "addOrupdateProductSpecification");
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.disabled=false
                    this.$message.error(res.message);
                }else{
                    this.disabled=false
                    this.$message.error(res.message);
                };
            },
        },
    }
</script>

<style lang="scss" scoped>
    /deep/ {
        .el-tree-node__label {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .el-tree-node__content{
            width: 100%;
        }
    }
    .menu{
        /*display: flex;*/
        border: 1px solid #8e8e8e;
        right: 0;
        position: absolute;
        background-color: #fff;
        box-shadow:0 2px 8px rgba(0,0,0,0.1);
    }
    .info{
        /*border: 1px solid #8e8e8e;*/
        padding: 5px 15px;
    }
    .info:hover{
        background-color: #CCCCCC;

    }

</style>